import workerize from 'notebook/workers/core/workerize';

const ContentWorkers = {
  stringify: workerize('stringify', (object: object) => JSON.stringify(object)),
};

export default ContentWorkers;
